import { useCallback, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { notificationApiRef } from '../../../../../apis/notificationApi';
import { iqeAgentApiRef } from '../../../../../apis/iqeAgentApi';
import { toTestSuites } from '../dto/responseDto/runResults.response.dto';
import type { IqeRunResultsRequest } from '../interfaces/api/requests/runResults.request';
import type { ITestSuite } from '../interfaces/ui';

export const useExecutionTestCases = () => {
  const notificationApi = useApi(notificationApiRef);
  const iqeAgentApi = useApi(iqeAgentApiRef);
  const [data, setData] = useState<ITestSuite[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const clearError = useCallback(() => setError(null), []);
  const reset = useCallback(() => {
    setData([]);
    setLoading(false);
    setError(null);
  }, []);

  const fetchTestCases = useCallback(
    async (request: IqeRunResultsRequest) => {
      setLoading(true);
      setError(null);
      try {
        const response = await iqeAgentApi.getIqeTestPlan(request);
        setData(toTestSuites(response));
      } catch (requestError) {
        const message = `Error: ${(requestError as Error).message}`;
        setError(message);
      } finally {
        setLoading(false);
      }
    },
    [notificationApi, iqeAgentApi],
  );

  return { data, loading, error, clearError, reset, fetchTestCases };
};
